import { useState, useEffect } from 'react';

const SLIDE_SELECTOR = '.hub-mobile-panel-carousel-slide';

/**
 * カルーセルのスクロール位置から現在表示中の実スライド index（0 ～ realCount-1）を返す。
 * コンテナの子は [最後のクローン, ...実スライド, 最初のクローン] の順であること。
 * @param {React.RefObject} containerRef - スクロールコンテナの ref
 * @param {number} realCount - 実スライド数（クローン除く）
 * @param {boolean} enabled - 有効にするか
 * @returns {number} 現在の実スライド index（0 ～ realCount-1）
 */
export function useCarouselActiveIndex(containerRef, realCount, enabled) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!enabled || !containerRef?.current || realCount < 1) return;

    const el = containerRef.current;
    const slides = el.querySelectorAll(SLIDE_SELECTOR);
    if (slides.length < realCount + 2) return;

    const update = () => {
      const scrollCenter = el.scrollLeft + el.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;

      for (let i = 1; i <= realCount; i++) {
        const slide = slides[i];
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const dist = Math.abs(scrollCenter - slideCenter);
        if (dist < bestDist) {
          bestDist = dist;
          best = i - 1;
        }
      }
      setActiveIndex(best);
    };

    let raf = null;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        update();
        raf = null;
      });
    };

    update();
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      el.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [containerRef, realCount, enabled]);

  return activeIndex;
}
